import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUS_OPTIONS, STATUS_STYLES, slugify } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusSelect = ({ complaint, onChange, disabled }) => {
  const style = STATUS_STYLES[complaint.status] || STATUS_STYLES.Menunggu;
  return (
    <Select value={complaint.status} onValueChange={(v) => v !== complaint.status && onChange(complaint.id, v)} disabled={disabled}>
      <SelectTrigger
        aria-label="Ubah status pengaduan"
        className={cn("h-9 w-[150px] rounded-full border px-3 text-xs font-semibold shadow-none", style.badge)}
        data-testid={`status-select-${complaint.id}`}
      >
        <span className="flex items-center gap-2">
          <span className={cn("h-2 w-2 rounded-full", style.dot)} />
          <SelectValue />
        </span>
      </SelectTrigger>
      <SelectContent className="bg-white">
        {STATUS_OPTIONS.map((s) => (
          <SelectItem key={s} value={s} data-testid={`status-option-${slugify(s)}`}>{s}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
